import React, { useRef } from 'react';
import { Download, Printer } from 'lucide-react';
import html2pdf from 'html2pdf.js';
import { useLanguage } from '../context/LanguageContext';

const JanmMrutyuAnuplabdhataForm = () => {
  const { language } = useLanguage();
  const componentRef = useRef();

  const handlePrint = () => {
    window.print();
  };

  const handleDownloadPdf = () => {
    const element = componentRef.current;
    const opt = {
      margin: 0,
      filename: language === 'marathi' ? 'Janm_Mrutyu_Anuplabdhata_Pramanpatra.pdf' : 'Non_Availability_Birth_Death_Certificate.pdf',
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { scale: 3, useCORS: true, logging: false },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
    };
    html2pdf().from(element).set(opt).save();
  };

  return (
    <div className="min-h-screen bg-gray-200 py-8 font-sans print:py-0 print:bg-white flex flex-col items-center">
      <style>
        {`
          @media print {
            @page {
              size: A4 portrait;
              margin: 0mm;
            }
            body {
              background-color: white !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }
          }
        `}
      </style>
      
      {/* Controls Container */}
      <div className="w-full max-w-[210mm] mb-6 flex justify-end space-x-4 print:hidden px-4">
        <button
          onClick={handlePrint}
          className="flex items-center px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 shadow-sm transition-colors"
        >
          <Printer className="w-4 h-4 mr-2" />
          {language === 'marathi' ? 'Print' : 'Print'}
        </button>
        <button
          onClick={handleDownloadPdf}
          className="flex items-center px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 shadow-sm transition-colors"
        >
          <Download className="w-4 h-4 mr-2" />
          {language === 'marathi' ? 'Download PDF' : 'Download PDF'}
        </button>
      </div>

      <div className="w-full overflow-x-auto flex justify-center">
        <div ref={componentRef} className="bg-white text-black shadow-lg print:shadow-none relative" style={{ width: '210mm' }}>
          
          <div className="px-14 py-16 mx-auto relative box-border flex flex-col" style={{ width: '210mm', minHeight: '297mm', maxHeight: '297mm', overflow: 'hidden' }}>
            
            <div className="text-center mb-8 space-y-4">
              <p className="font-bold text-lg">{language === 'marathi' ? 'नमुना क्रमांक- १० (ब)' : 'Form No. 10 (B)'}</p>
              <p className="text-[15px]">{language === 'marathi' ? '(नियम १३ पाहा)' : '(See Rule 13)'}</p>
              <h1 className="text-xl font-bold border-b-[1.5px] border-black inline-block pb-0.5 mt-2">
                {language === 'marathi' ? 'जन्म / मृत्यू नोंद अनुपलब्धता प्रमाणपत्र' : 'Non-availability Certificate of Birth/Death Record'}
              </h1>
              <p className="text-[15px] mt-3">{language === 'marathi' ? '(जन्म आणि मृत्यू नोंदणी अधिनियम, १९६९ च्या कलम १७ अन्वये दिलेले)' : '(Issued under Section 17 of the Registration of Births and Deaths Act, 1969)'}</p>
            </div>

            <div className="text-[15px] leading-loose mt-4">
               <div className="flex flex-wrap items-end mb-2">
                  <span className="mr-1">{language === 'marathi' ? 'प्रमाणित करण्यात येते की,' : 'This is to certify that, on the request of'}</span>
                  <span className="font-bold mr-1">{language === 'marathi' ? 'श्री./श्रीमती/ कुमारी' : 'Mr./Mrs./Miss'}</span>
                  <span className="border-b border-dashed border-black flex-grow"></span>
                  <span className="font-bold mx-1">{language === 'marathi' ? 'श्री.' : 'Mr.'}</span>
                  <span className="border-b border-dashed border-black w-24"></span>
               </div>
               <div className="flex flex-wrap items-end mb-8">
                  <span className="border-b border-dashed border-black w-64 mr-1"></span>
                  <span>{language === 'marathi' ? 'यांची/यांचा मुलगा/ पत्नी/ मुलगी यांच्या विनंतीवरुन' : 'his/her son/wife/daughter'}</span>
               </div>

               <div className="flex flex-wrap items-end mb-8">
                  <span className="font-bold mr-1">{language === 'marathi' ? 'श्री./श्रीमती/ कु.' : 'Mr./Mrs./Miss'}</span>
                  <span className="border-b border-dashed border-black flex-grow"></span>
                  <span className="ml-1">{language === 'marathi' ? 'यांचा/यांची पत्नी/मुलगा/मुलगी' : 'his/her wife/son/daughter'}</span>
               </div>

               <div className="flex flex-wrap items-end mb-1">
                  <span className="border-b border-dashed border-black w-56 mr-1"></span>
                  <span className="mr-1">{language === 'marathi' ? '(स्थानिक क्षेत्र) तहसील' : '(Local area) Tehsil'}</span>
                  <span className="border-b border-dashed border-black flex-grow"></span>
                  <span className="mx-1">{language === 'marathi' ? 'जि.' : 'Dist.'}</span>
                  <span className="border-b border-dashed border-black w-48"></span>
               </div>
               <div className="flex flex-wrap items-end mb-1">
                  <span className="border-b border-dashed border-black w-24 mr-1"></span>
                  <span className="mr-1">{language === 'marathi' ? 'राज्य-महाराष्ट्र या' : 'State-Maharashtra, a search of the registration records for the year'}</span>
                  <span className="border-b border-dashed border-black w-48 mr-1"></span>
                  <span>{language === 'marathi' ? 'वर्षाचे नोंदणी अभिलेखाचा शोध घेण्यात आला आणि असे' : 'was made and it was'}</span>
               </div>
               <div className="flex flex-wrap items-end mb-1">
                  <span className="mr-1">{language === 'marathi' ? 'दिसून आले की,' : 'found that no record of the birth/death event relating to'}</span>
                  <span className="border-b border-dashed border-black flex-grow"></span>
                  <span className="ml-1">{language === 'marathi' ? 'च्या मुलगा/मुलगी/पत्नीच्या संबंधी जन्म/मृत्यू घटनेची' : 'the son/daughter/wife of has been'}</span>
               </div>
               <p className="mt-1">
                  {language === 'marathi' ? 'नोंद करण्यात आलेली नाही.' : 'recorded.'}
               </p>
            </div>

            {/* Signatures area positioned towards the bottom of the content */}
            <div className="flex justify-between items-start mt-32 text-[15px]">
               <div className="w-1/2">
                  <p className="font-bold text-lg">{language === 'marathi' ? 'दिनांक:' : 'Date:'}</p>
               </div>
               <div className="w-1/2 flex flex-col items-center">
                  <p className="font-bold text-[15px] mb-8 text-center">{language === 'marathi' ? 'निर्गमित करणा-या प्राधिका-याची सही व दिनांक' : 'Signature and date of issuing authority'}</p>
                  <p className="text-[15px] font-bold">{language === 'marathi' ? 'सील' : 'Seal'}</p>
               </div>
            </div>

            <div className="absolute bottom-10 left-14 text-blue-700 text-sm underline print:hidden">
              www.majhigrampanchayat.com
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default JanmMrutyuAnuplabdhataForm;
